import Header from './components/Header/Header'
import Body from './components/Body/Body'
import { useContext , useEffect } from 'react'
import { CurrentPage , UserValues } from './Context/Context'
import UserData from './API/UserData'


function App() {

  const [ currentPageState , setCurrentPageState ] = useContext(CurrentPage)
  const [userValuesState, setuserValuesState] = useContext(UserValues);

  useEffect(() => {


    if (userValuesState.idClient == 0) {
      setuserValuesState({ ...userValuesState, idClient: Math.floor(Math.random() * (1000000000 - 100) + 1) });
    }

  }, []);


  
  return (
    <>
    <UserData >
     <Header /> 
    <Body type={currentPageState} />
    </UserData>
    </>
  );
}

export default App;
